// extracted by mini-css-extract-plugin
module.exports = {"section":"StoreVerification-section-wOAQC","p":"StoreVerification-p-60XdF","button":"StoreVerification-button-E1aRn"};